/**
 * Tutorials JS
 */
;(function ($) {
    // Make the whole tutorial card clickable.

    var card = null;
    var clickableElements = null;
    var cardOnDashboard = $('#dashboard-tutorials .shipper-tutorial-item');

    if ( cardOnDashboard.length ) {
        card = cardOnDashboard;
        clickableElements = $('#dashboard-tutorials .shipper-tutorial-item a');
    } else {
        card = $('#shipper-page-tutorials .shipper-tutorial-post-wrapper');
        clickableElements = $('#shipper-page-tutorials .shipper-tutorial-post-wrapper a');
    }

    clickableElements = Array.from( clickableElements );
    clickableElements.forEach( function(ele) {
        $(ele).on('click', function(event) {
            event.stopPropagation();
        });
    });

    card.on('click', function(event) {
        if ( window.getSelection().toString() ) {
            return;
        }

        var link = $(event.currentTarget).find('a');

        if ( link && link.get(0) ) {
            link.get(0).click();
        }
    });

    /**
     * @namespace aria
     */
    var aria = aria || {};

    // Key codes.
    aria.KeyCode = {
        TAB: 9,
        RETURN: 13,
        ESC: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        DELETE: 46
    };

    // Handling accessibility for the tutorials tab.
    $( '#shipper-page-tutorials div[role="link"]' ).on( 'keydown', function( e ) {

        var focusOnNextTut = function( direction ) {
            var current = $( ref ).data( 'tutorial' ),
                next = 'next' === direction ? current + 1 : current - 1;

            var $nextTut = $( '#shipper-page-tutorials [data-tutorial="' + next + '"]' );

            // When we are at the end and moving forward, or at the beginning and moving backward.
            if ( ! $nextTut.length ) {
                var allTuts = $( '#shipper-page-tutorials .shipper-tutorial-post-wrapper' ),
                    nextTutKey = 'next' === direction ? 0 : allTuts.length - 1;
                $nextTut = allTuts[ nextTutKey ];
            }

            $nextTut.focus();
        }

        var key = e.which || e.keyCode,
            ref = e.target !== null ? e.target : e.srcElement;

        switch ( key ) {

            case aria.KeyCode.RETURN :
                if ( ref ) {
                    window.open( ref.getAttribute( 'data-href' ), '_blank' );
                }
                break;

            case aria.KeyCode.LEFT :
                focusOnNextTut( 'prev' );
                break;

            case aria.KeyCode.RIGHT :
                focusOnNextTut( 'next' );
                break;
        }
    });

    // Hide shipper tutorials
    var hideBtn = $( '#dashboard-tutorials .hide-shipper-tutorials' );

    hideBtn.on('click', function(event) {
       event.preventDefault();

       $.post( ajaxurl, {
           action: 'shipper_hide_tutorials',
           _wpnonce: hideBtn.data('nonce'),
       });

       $('#dashboard-tutorials').slideUp();
    });

})(jQuery);